import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { enStyle } from '../../style/enStyle'
import { faStyle } from '../../style/faStyle'
import './style.scss'
import Search from './search/Search'
import { MdLanguage } from 'react-icons/md'
import { fetchSaloons } from '../../redux/action/saloons/saloons';
import ScreenLoading from '../../utils/ScreenLoading'

const HomeNavbar = () => {
    const saloons = useSelector(state => state.saloons)
    const dispatch = useDispatch()
    const {t, i18n} = useTranslation();

    const changeLangToFa = () => { localStorage.setItem("lang", "fa"); i18n.changeLanguage("fa"); faStyle()}
    const changeLangToEn = () => { localStorage.setItem("lang", "en"); i18n.changeLanguage("en"); enStyle()}
    const changeLangToAr = () => { localStorage.setItem("lang", "ar"); i18n.changeLanguage("ar"); faStyle()}

    useEffect(() => {
        if(!saloons.saloons.length) {
            dispatch(fetchSaloons())
        }
    }, [])

    return (
        <div className='main_navbar'>
            {saloons.loading ? 
                <ScreenLoading />
            :
                <Container>
                    <Navbar expand="lg" >
                        <Link className='navbar-brand' to="/">{t("nav_logo")}</Link>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav className="me-auto my-2 my-lg-0" navbarScroll >
                            <NavDropdown title={t("lang")} id="mobile_lang">
                                <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                                <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                                <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                            </NavDropdown>
                                {saloons.saloons.length ?
                                    <NavDropdown title={t("halls")} id="hallsDropdown">
                                        {saloons.saloons.map(saloon => (
                                            <NavDropdown.Item className='nav_saloon' key={saloon.id} as={Link} to={`/saloon/${saloon.id}`}>
                                                {saloon.name}
                                            </NavDropdown.Item>
                                        ))}
                                    </NavDropdown>
                                : 
                                    <NavLink activeClassName="H_active_class" className="nav-link" to="/saloons">{t("halls")}</NavLink>
                                }
                                <NavLink activeClassName="H_active_class" className="nav-link" to="/companies"> {t("companies")} </NavLink>
                                <NavLink activeClassName="H_active_class" className="nav-link" to="/exhibition" target="_blank">{t("visit_expo")}</NavLink>
                                <NavLink activeClassName="H_active_class" className="nav-link" to="/register">{t("Participate_expo")}</NavLink>
                                <NavLink activeClassName="H_active_class" className="nav-link" to="/login"> {t("exhibitors")} </NavLink>
                            </Nav>
                            <Search />
                            <NavDropdown title={<MdLanguage />} id="lang">
                                <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                                <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                                <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                            </NavDropdown>
                        </Navbar.Collapse>
                    </Navbar>
                </Container>
            }
        </div>
    )
}

export default HomeNavbar
